(() => {
  const mobile = window.matchMedia('(max-width: 989px)');
  if (!mobile.matches) return;

  const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const cleanHref = (href) => {
    try { return new URL(href, window.location.origin).pathname + new URL(href, window.location.origin).search; }
    catch (_) { return href || '#'; }
  };

  const buildMenu = () => {
    if (document.querySelector('.aury-mobile-menu')) return document.querySelector('.aury-mobile-menu');

    const menu = document.createElement('div');
    menu.className = 'aury-mobile-menu';
    menu.setAttribute('data-open','false');
    menu.setAttribute('aria-hidden','true');

    // Prefer the same links that are visible in the desktop header so mobile and desktop cannot drift apart.
    const candidates = [...document.querySelectorAll('header a, #header-component a')]
      .filter(a => a.offsetParent !== null || a.closest('.header'))
      .map(a => ({ text:(a.textContent||'').replace(/\s+/g,' ').trim(), href:a.href }))
      .filter(x => x.text && x.href && !x.href.includes('#'));

    const dedup = [];
    const seen = new Set();
    for (const item of candidates) {
      const key = item.text.toLowerCase();
      if (seen.has(key)) continue;
      if (/konto|account|warenkorb|cart|suche|search/i.test(item.text)) continue;
      seen.add(key); dedup.push(item);
      if (dedup.length >= 8) break;
    }

    const links = dedup.length ? dedup : [
      { text:'Startseite', href:rootUrl },
      { text:'Shop', href:`${rootUrl}collections/all` },
      { text:'Kontakt', href:`${rootUrl}pages/kontakt` }
    ];

    // Always make Startseite safe: route it to Shopify root rather than a possibly stale page URL.
    for (const item of links) if (/^startseite$/i.test(item.text)) item.href = rootUrl;

    // AURYMED legal/service links belong in the mobile navigation as well.
    if (!links.some(x => /liefer|versand/i.test(x.text))) links.push({ text:'Lieferung & Versand', href:`${rootUrl}pages/liefer-und-versandinformationen` });
    if (!links.some(x => /elektro/i.test(x.text))) links.push({ text:'ElektroG', href:`${rootUrl}pages/elektrog` });

    menu.innerHTML = `<div class="aury-mobile-menu__backdrop" data-aury-mobile-close></div>
      <aside class="aury-mobile-menu__panel" role="dialog" aria-modal="true" aria-label="Navigation">
        <div class="aury-mobile-menu__head"><span class="aury-mobile-menu__brand">AURYMED</span><button class="aury-mobile-menu__close" type="button" aria-label="Menü schließen" data-aury-mobile-close>×</button></div>
        <nav class="aury-mobile-menu__nav">${links.map(x=>`<a href="${cleanHref(x.href)}">${x.text}</a>`).join('')}</nav>
        <div class="aury-mobile-menu__foot">Deine Inspiration zu dir selbst</div>
      </aside>`;
    document.body.appendChild(menu);
    document.documentElement.classList.add('aury-mobile-fallback-ready');
    return menu;
  };

  const open = () => {
    const menu = buildMenu();
    menu.dataset.open='true'; menu.setAttribute('aria-hidden','false');
    document.body.classList.add('aury-mobile-menu-open');
    menu.querySelector('.aury-mobile-menu__close')?.focus({preventScroll:true});
  };
  const close = () => {
    const menu = document.querySelector('.aury-mobile-menu'); if (!menu) return;
    menu.dataset.open='false'; menu.setAttribute('aria-hidden','true');
    document.body.classList.remove('aury-mobile-menu-open');
  };

  const bind = () => {
    buildMenu();
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('.header__icon--menu, #Details-menu-drawer-container > summary');
      if (trigger) {
        e.preventDefault(); e.stopPropagation();
        open(); return;
      }
      if (e.target.closest('[data-aury-mobile-close]')) { e.preventDefault(); close(); }
    }, true);
    document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });

    // On mobile, never allow AURYMED decorative effects to leave content hidden.
    document.querySelectorAll('.aury-reveal').forEach(el => el.classList.add('is-visible'));
    document.querySelectorAll('.aury-orbit-dock').forEach(el => el.remove());
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind, {once:true}); else bind();
})();
